import feathersClient, {
  makeServicePlugin,
  BaseModel
} from '../../feathers-client'

class SavedSearch extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'SavedSearch'
  // Define default properties here
  static instanceDefaults() {
    return {
      mode: 'AND',
      query:[
        {
          field: null,
          opcode: null,
          value: null
        }
      ],
      columns: [
        'acbFindingFile',
        'acbACB',
        'acbAudit',
        'acbDate',
        'acbClass',
        'acbFinding_Type',
        'acbCloseDate'
      ]
    }
  }
  // static setupInstance(data) {
  //   if (data.createdAt) {
  //     data.createdAt = new Date(data.createdAt)
  //   }
  //   return data
  // }
}
const servicePath = 'saved-searches'
const servicePlugin = makeServicePlugin({
  Model: SavedSearch,
  service: feathersClient.service(servicePath),
  servicePath,
  debug: true
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
